<template>
    <div class="tab-content">
        <slot></slot>
    </div>
</template>
